/* 🤖 this file was generated by svg-to-ts */
export const mgcIconTv1Filled: {
  name: 'tv-1-filled';
  data: string;
} = {
  name: 'tv-1-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3.58 4.047c-.733.14-1.4.821-1.537 1.57-.06.332-.06 10.434 0 10.766.141.768.806 1.433 1.574 1.574.334.061 16.432.061 16.766 0 .768-.141 1.433-.806 1.574-1.574.06-.332.06-10.434 0-10.766-.141-.768-.806-1.433-1.574-1.574-.308-.056-16.508-.052-16.803.004m4.063 15.022C7.291 19.193 7 19.614 7 20c0 .242.119.521.299.701.317.317.038.299 4.701.299s4.384.018 4.701-.299a.984.984 0 0 0 0-1.402c-.317-.317-.035-.299-4.718-.296-3.663.003-4.184.011-4.34.066"/></svg>`
};
